import React from 'react'

export const Footer = () => {
  return (
    <footer className="container footer">
      <a
        href="https://github.com/tyooma"
        target="_blank"
        rel="noreferrer"
        className="badge badge-light">
        deved by Tyooma
      </a>
    </footer>
  )
}
